import { LoginGtm } from '../utils/gtm/auth/loginGtm';
import { useHistoryMethod } from '../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../utils/hook/usePathnameMethod';

const NavbarLoginButton = () => {
  const { pathname, search } = usePathnameMethod();
  const history = useHistoryMethod();

  const onClickLoginPage = () => {
    const loginGtm = new LoginGtm();
    loginGtm.click_signup();

    return history.pushToLogin({ redirectURI: pathname + search });
  };

  return (
    <div className="relative">
      <button
        onClick={onClickLoginPage}
        className={`h-30px w-107px rounded-full border border-gray-800 text-14px font-semibold text-gray-800`}
        type="button"
      >
        로그인·회원가입
      </button>
    </div>
  );
};

export default NavbarLoginButton;
